import FeatureConfigApi from "../../services/api/FeatureConfig";
import ActionTypes from "./ActionTypes";
import { setStatus, setLoader } from "./User";
import Errors from "../../constants/Errors.json";
import _ from "lodash";
import { element } from "prop-types";

const entities = [
  {
    id: 1,
    name: "config",
  },
  {
    id: 2,
    name: "namespace",
  },
];



export const setNamespaces = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_CONFIG_NAMESPACES,
    payload,
  };
};

export const setKeys = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_CONFIG_KEYS,
    payload,
  };
};

export const setConfigs = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_CONFIGS,
    payload,
  };
};

export const setActiveHierarchyFiltersConfig = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_HIERARCHY_FILTERS_CONFIG,
    payload,
  };
};

export const resetStateFeatureConfig = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_FEATURE_CONFIG,
    payload,
  };
};

export const setCurrentNamespace = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_CONFIG_CURRENT_NAMESPACE,
    payload,
  };
};

export const setCurrentKey = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_CONFIG_CURRENT_KEY,
    payload,
  };
};

export const setPrevPage = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_CONFIG_PREV_PAGE,
    payload,
  };
};

export const setNextPage = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_CONFIG_NEXT_PAGE,
    payload,
  };
};

export const setUserData = (payload) => {
  return {
    type: ActionTypes.SET_FEATURE_CONFIG_USER_DATA,
    payload,
  };
};

export const getNamespaces =
  (pageRequest = {}) =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await FeatureConfigApi.getNamespaces();
      dispatch(setLoader(false));
      // const namespaces = response.namespaces?.map((namespaceObject) => namespaceObject?.namespace)
      if (response) {
        dispatch(
          setNamespaces({
            namespaces: response.namespaces,
          })
        );
      }
      return {
        namespaces: response.namespaces,
      };
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
    }
  };

export const getKeys = (namespace) => async (dispatch) => {
  try {
    if (namespace == "") {
      return [];
    }
    dispatch(setLoader(true));
    let response = await FeatureConfigApi.getKeys(namespace);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setKeys({
          keys: response.keys,
        })
      );
    }
    return {
      keys: response.keys,
    };
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
  }
};

export const filterKeyConfigs =
  (payload = {}) =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await FeatureConfigApi.filterKeyConfigs(payload);
      dispatch(setLoader(false));
      if (
        !payload.filters?.key &&
        payload.filters?.hierarchy?.entity == undefined
      ) {
        payload.filters = {
          hierarchy: {
            entity: "",
            entityId: "",
          },
        };
      }
      if (response) {
        dispatch(setPrevPage(payload.page - 1));
        if (response.pagination.nextPageToken) {
          dispatch(setNextPage(payload.page + 1));
        } else {
          dispatch(setNextPage(-1));
        }
        dispatch(setConfigs(response.keyConfigs));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
    }
  };

export const upsertConfig =
  (payload = {}) =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await FeatureConfigApi.upsertConfig(payload);
      dispatch(setLoader(false));
      if (response.namespaceStatuses) {
        const statusObject = response.namespaceStatuses[0].configStatuses[0];
        if (statusObject.status == "failure") {
          dispatch(
            setStatus({
              type: "error",
              message: statusObject.errorMessage,
            })
          );
          return null;
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
    }
  };

export const getNamespace = (namespace) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FeatureConfigApi.getNamespace(namespace);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
  }
};

export const getUploadUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FeatureConfigApi.getUploadUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
  }
};

export const getEntities = (async) => {
  return new Promise((resolve, reject) =>
    resolve({
      entities,
    })
  );
};

export const getEntityNames = (ids) => {
  return entities
    .filter((element) => ids.includes(element.id))
    .map((el) => el.name);
};

export const getEntityIds = (names) => {
  return entities
    .filter((element) => names.includes(element.name))
    .map((el) => el.id);
};

export const getEntityObjects = (ids) => {
  return new Promise((resolve, reject) => {
    resolve(entities.filter((element) => ids.includes(element.id)));
  });
};

export const getUser = (email) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FeatureConfigApi.getUser(email);
    dispatch(setLoader(false));
    if (response) {
      if (!response.user) {
        response.user = {
          email: email,
        }
      }

      dispatch(
        setUserData({
          user: response.user,
        })
      );
      
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
  }
};

export const upsertUser = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await FeatureConfigApi.upsertUser(payload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
  }
};
